<div *ngIf="isRiskProject" class="overread-settings">
  <div class="overread-title">Claim Codes</div>

  <div class="disclaimer-text">
   Deficient refers to any chase where a unique Claims HCC was not validated (VRC 39)
    during primary data entry (medical record review) or new HCC has been added by the coder. 
    Non-Deficient is a chase where all unique Claims HCCs were validated (VRC 00) during primary data
     entry (medical record review).
  </div>


  <div class="overread-header-row">
    <div class="header-placeholder"></div>
    <div class="header-cell">Deficient</div>
    <div class="header-cell">Non-Deficient</div>
  </div>

  <div *ngFor="let item of projectConfigForm.get('Overread')['controls']; let i = index; trackBy: trackByIndex" [formGroup]="item" class="overread-row">
    <div class="overread-label-section">
      <span class="overread-label">OVERREAD I</span>
      <app-tool-tip [text]="overread1Description"></app-tool-tip>
      <div class="toggle-wrapper">
        <form-factory [formGroup]="riskFormGroup" [model]="overreadIEnabled"></form-factory>
      </div>
    </div>

    <div class="input-cell">
      <input type="text" [attr.id]="'deficient' + i" formControlName="Deficient" class="control__input control__input--textbox text-center percentage" (blur)="deficientChaseBlur.emit({ group: 'Overread', index: i })"/>
         <div class="errorMessage" *ngIf="item.controls.Deficient.invalid && item.controls.Deficient.touched">
    * Percentage must be between 0 - 100
    </div>
    </div>

    <div class="input-cell">
      <input type="text" [attr.id]="'nondeficient' + i" formControlName="NonDeficient"class="control__input control__input--textbox text-center percentage"/>
   <div class="errorMessage" *ngIf="item.controls.NonDeficient.invalid && item.controls.NonDeficient.touched">
    * Percentage must be between 0 - 100
    </div>
    </div>
  </div>

  <div *ngFor="let item of projectConfigForm.get('Overread2')['controls']; let i = index; trackBy: trackByIndex" [formGroup]="item" class="overread-row">
    <div class="overread-label-section">
      <span class="overread-label">OVERREAD II</span>
      <app-tool-tip [text]="overread2Description"></app-tool-tip>
      <div class="toggle-wrapper">
        <form-factory [formGroup]="riskFormGroup" [model]="overreadIIEnabled"></form-factory>
      </div>
    </div>

    <div class="input-cell">
      <input type="text" [attr.id]="'deficient' + i" formControlName="Deficient" class="control__input control__input--textbox text-center percentage"(blur)="deficientChaseBlur.emit({ group: 'Overread2', index: i })"/>
     <div class="errorMessage" *ngIf="item.controls.Deficient.invalid && item.controls.Deficient.touched">
      * Percentage must be between 0 - 100
    </div>
    </div>

    <div class="input-cell">
      <input type="text" [attr.id]="'nondeficient' + i" formControlName="NonDeficient"class="control__input control__input--textbox text-center percentage"/>
     <div class="errorMessage" *ngIf="item.controls.NonDeficient.invalid && item.controls.NonDeficient.touched">
    * Percentage must be between 0 - 100
    </div>
    </div>
  </div>
</div>
